import { render, staticRenderFns } from "./MirrorTable.vue?vue&type=template&id=5a8aabf0&scoped=true&"
import script from "./MirrorTable.vue?vue&type=script&lang=js&"
export * from "./MirrorTable.vue?vue&type=script&lang=js&"
import style0 from "./MirrorTable.vue?vue&type=style&index=0&id=5a8aabf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8aabf0",
  null
  
)

export default component.exports